import {
  createComponent,
  type ElementWithProps
} from '@carvana/merch-components';
import cx from 'classnames';

export const FullScreenWrapper = createComponent('div', {
  className:
    'fixed inset-0 z-[9999] grid h-screen w-screen grid-rows-[64px_1fr_130px] bg-black bg-opacity-90 pb-16'
});

export const CarouselWrapper = createComponent('div', {
  className: 'flex items-center overflow-hidden',
  'data-qa': 'carousel-wrapper'
});

export const ExternalSideBarNav = createComponent('ul', {
  className: 'hidden overflow-y-hidden overflow-x-scroll m:flex',
  'data-qa': 'external-side-bar-nav'
});

export type SideBarImageProps = ElementWithProps<
  { selected: boolean },
  HTMLLIElement
>;

export const SideBarImage = createComponent<SideBarImageProps>('li', props => ({
  className: cx(
    'm-4 min-h-[92px] min-w-[166px] bg-cover bg-center bg-no-repeat',
    props.selected
      ? '[background-image:linear-gradient(rgba(0,174,217,0.45),rgba(0,174,217,0.45)),var(--cv-image-url)]'
      : '[background-image:var(--cv-image-url)]'
  )
}));

export const ImageTitle = createComponent('div', {
  className:
    'mx-auto grid w-fit grid-flow-col items-center gap-8 justify-self-start'
});

export const Container = createComponent('div', {
  className: 'flex h-full w-full items-center justify-between py-4'
});

export const SliderWrapper = createComponent('div', {
  className: 'px-sm-32 h-full w-full px-0 pt-[100px] m:px-[100px] m:pb-40'
});

export const SliderImageWrapper = createComponent('div', {
  className: `
    mx-auto
    !grid
    h-fit
    max-h-full
    !w-screen
    max-w-full
    grid-cols-[75px_1fr_75px]
    grid-rows-[minmax(0,1fr)_auto]
    gap-16
    text-white
    m:aspect-[4/3]
    m:!w-fit
    m:grid-cols-[100px_1fr_100px]`
});

export const NavButton = createComponent('div', {
  className: `
    absolute
    mx-20
    flex
    h-[58px]
    min-w-[58px]
    max-w-[58px]
    items-center
    justify-center
    rounded-full
    bg-white
    shadow-[0_6px_13px_rgb(24_53_88_/_0.1)]`
});

export const PrevNavButton = createComponent(NavButton, {
  className: 'left-0'
});

export const NextNavButton = createComponent(NavButton, {
  className: 'right-0'
});
